if (!customElements.get('testimonials-component')) {
  customElements.define(
    'testimonials-component',
    class Testimonials extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.enableSlider = this.dataset.enableSlider === 'true';
        if (!this.enableSlider) return;

        this.selectors = {
          sliderWrapper: '.testimonials__items',
          sliderControls: '.slider-controls--group',
          paginationEl: '.swiper-pagination',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        };

        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
          swiperControlsVisible: 'slider-controls--grouped-always',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.sliderControls = this.querySelector(this.selectors.sliderControls);
        this.enableSwipe = this.dataset.enableSwipe === 'true';

        this.slideEls = this.sliderWrapper.querySelectorAll('.swiper-slide');
        this.totalItems = this.slideEls.length;
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);

        this.sliderInstance = false;

        this.init();
        document.addEventListener('matchMobile', () => {
          this.init();
        });
        document.addEventListener('unmatchMobile', () => {
          this.init();
        });
        document.addEventListener('matchTablet', () => {
          this.init();
        });
        document.addEventListener('unmatchTablet', () => {
          this.init();
        });
      }

      init() {
        if (AfcTheme.config.mqlMobile) {
          if (!this.enableSwipe) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        } else {
          this.columnsToShow = AfcTheme.config.mqlTablet ? this.tabletItems : this.items;

          if (this.totalItems > this.columnsToShow) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        const sliderOptions = {
          slidesPerView: 1,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.section.querySelector(this.selectors.paginationEl),
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
            },
            1024: {
              slidesPerView: this.items,
            },
          },
          loop: true,
          threshold: 2,
        };

        this.sliderControls.classList.remove('!hidden');
        this.classList.add(this.classes.swiperControlsVisible);
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.AfcTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = AfcTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);

            this.sliderInstance.slider.slideToLoop(index);
          });
        }
      }

      destroySlider() {
        this.sliderControls.classList.add('!hidden');
        this.classList.remove(this.classes.swiperControlsVisible);
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);

        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }
    }
  );
}
